import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fmtPrice, optimizeImg } from "../lib/api";

const statusStyles = {
  available: "text-emerald-300 border-emerald-400/40",
  reserved: "text-amber-300 border-amber-400/40",
  sold: "text-neutral-300 border-white/20",
};

export const BoaCard = ({ boa, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    <Link
      to={`/boa/${boa.id}`}
      data-testid={`boa-card-${boa.id}`}
      className="group flex flex-col h-full overflow-hidden rounded-xl border border-white/10 bg-qbsurface text-qbfg hover:border-qbprimary/40 transition-colors"
    >
      {/* Clean photo — no darkening overlay */}
      <div className="relative overflow-hidden aspect-[4/5]">
        <img
          src={optimizeImg(boa.images?.[0], 600)}
          alt={boa.name}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
        />
        <span
          className={`absolute top-2 left-2 z-10 text-[9px] sm:text-[10px] uppercase tracking-[0.15em] px-2 py-0.5 rounded-full border bg-black/60 backdrop-blur ${statusStyles[boa.status] || statusStyles.available}`}
        >
          {boa.status}
        </span>
      </div>

      {/* Info panel below the photo */}
      <div className="flex flex-col flex-1 p-2.5 sm:p-4">
        <h3 className="font-display leading-tight text-sm sm:text-lg md:text-xl truncate">{boa.name}</h3>
        <div className="flex items-center justify-between gap-2 mt-1">
          <span className="text-[10px] sm:text-xs text-qbfg/55">{boa.sex} · {boa.year}</span>
          <span className="font-body text-xs sm:text-base font-semibold text-qbprimary whitespace-nowrap">{fmtPrice(boa.price)}</span>
        </div>
      </div>
    </Link>
  </motion.div>
);
